import { render } from "./page-head.vue?vue&type=template&id=06c1fe2a&scoped=true&ts=true"
import script from "./page-head.vue?vue&type=script&lang=ts"
export * from "./page-head.vue?vue&type=script&lang=ts"

import "./page-head.vue?vue&type=style&index=0&id=06c1fe2a&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c1fe2a"]])

export default __exports__